import { useEffect } from 'react'
import { reactQueryErrorHandler } from '@dg-util'
import { ResponseErrorV2Type } from '../../types/ApiV2'
import { FSMService } from '../../FSM'

/**
 * Drives the FSM on a failed query. Replaces the query-level `onError` option that
 * @tanstack/react-query removed in v5 (it survives on mutations only).
 *
 * Kept per-observer and opt-in, matching the v4 behaviour: a query that deliberately
 * has no error handling (see the signOut query in useReactQueryAuth) simply does not
 * call this. A global QueryCache `onError` would be opt-out instead, and would make
 * queryClient.ts import the FSM — a cycle, since storageClear already imports queryClient.
 */
const useReactQueryErrorEffect = (error: unknown, backState?: string) => {
  useEffect(() => {
    if (!error) return

    reactQueryErrorHandler(error as ResponseErrorV2Type, FSMService.flowService, backState)
    // Guarded on the error object identity: react-query holds one error instance per
    // failure, so this sends a single FSM event per failed query.
  }, [error, backState])
}

export default useReactQueryErrorEffect
